import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
    Box,
    FormControl,
    FormControlLabel,
    RadioGroup,
    Radio,
    TextField,
    IconButton,
    // Iconify,
    Divider
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import Iconify from "src/components/iconify/Iconify";
import { useState } from 'react';

const cancelReasons = [
    "Change in dining plans",
    "Unexpected scheduling conflict",
    "Health concerns or illness",
    "Found another dining option",
    "Transportation issues",
    "Weather conditions",
    "Party size changed unexpectedly",
    "Venue location inconvenience",
    "Budgetary constraints",
    "Personal emergency or unforeseen circumstances",
    "Other"
];

const CancelReasonDialog = ({
    open,
    onClose,
    onConfirm,
    loading = false
}) => {
    const [selectedReason, setSelectedReason] = useState('');
    const [customReason, setCustomReason] = useState('');

    const handleConfirm = () => {
        const finalReason = selectedReason === 'Other' ? customReason : selectedReason;
        onConfirm(finalReason);
        setSelectedReason('');
        setCustomReason('');
    };

    const handleClose = () => {
        onClose();
        setSelectedReason('');
        setCustomReason('');
    };

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
            <DialogTitle>
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",

                    }}
                >
                    <Box>
                        <Typography varient="h3" sx={{ fontWeight: "bold", fontSize: "20px" }}>Reason for Cancellation</Typography>
                    </Box>
                    <IconButton aria-label="close" onClick={() => onClose(!open)}>
                        <Iconify
                            sx={{
                                height: 25,
                                width: 25,
                            }}
                            icon="mdi:close"
                            color="#fca92e"
                        />
                    </IconButton>
                </Box>
            </DialogTitle>
            <Box>
                <Divider />
            </Box>
            <DialogContent>
                <FormControl component="fieldset" fullWidth>
                    <RadioGroup
                        name="cancelReason"
                        value={selectedReason}
                        onChange={(e) => setSelectedReason(e.target.value)}
                    >
                        {cancelReasons.map((reason) => (
                            <FormControlLabel
                                key={reason}
                                value={reason}
                                control={
                                    <Radio
                                        sx={{
                                            color: "#F59B34",
                                            '&.Mui-checked': {
                                                color: "#F59B34",
                                            },
                                        }}
                                    />
                                }
                                label={
                                    <Typography sx={{ fontSize: 14 }}>{reason}</Typography>
                                }
                            />
                        ))}
                    </RadioGroup>
                </FormControl>

                {selectedReason === "Other" && (
                    <Box mt={2}>
                        <Typography variant="subtitle2">Please specify:</Typography>
                        <TextField
                            fullWidth
                            multiline
                            rows={3}
                            value={customReason}
                            onChange={(e) => setCustomReason(e.target.value)}
                            placeholder="Enter custom reason"
                            sx={{ mt: 1 }}
                        />
                    </Box>
                )}
            </DialogContent>

            <DialogActions>
                <LoadingButton onClick={handleClose} variant="outlined">
                    Cancel
                </LoadingButton>
                <LoadingButton
                    loading={loading}
                    variant="contained"
                    sx={{
                        bgcolor: "#F59B34",
                        color: "#000",
                        "&:hover": { bgcolor: "#B66816" }
                    }}
                    onClick={handleConfirm}
                    disabled={
                        !selectedReason || (selectedReason === "Other" && customReason.trim() === "")
                    }
                >
                    Confirm
                </LoadingButton>
            </DialogActions>
        </Dialog>
    );
};

export default CancelReasonDialog;
